export const faqs = [
  {
    q: "这些爆料内容是从哪里来的？",
    a: "内容主要来自知情人、线人、内部从业者的匿名投递与口述整理，部分稿件包含书面材料、截图或台账线索作为交叉印证。我们会在每篇稿件中标注信源类型（如“线人代号”“前员工受访”），并说明哪些部分是口述、哪些部分有材料支撑。",
  },
  {
    q: "如何保证爆料人的匿名安全？",
    a: "投稿渠道不收集可识别身份的信息，线人代号在编辑部内部随机生成，正文中不出现真实姓名、工号、精确门店或住址。涉及敏感细节时，我们会主动做模糊处理，例如把具体日期改为时间段、把金额改为区间。",
  },
  {
    q: "我可以自己提交爆料吗？需要提供证据吗？",
    a: "可以。任何人都能通过“我要爆料”页面匿名提交线索。证据不是硬性要求，我们理解很多知情人无法直接拿出书面材料。但如果你手上有截图、录音文字、单据等线索，会显著帮助我们判断可信度。请不要上传涉及他人隐私的原件。",
  },
  {
    q: "被爆料的一方有权回应吗？",
    a: "有。发布前我们会通过公开渠道向被指涉方发出问询，并在稿件末尾保留“回应”区块。如果对方给出说明，我们会如实呈现，即使这与线人的口述存在冲突。稿件发布后，也欢迎相关方继续补充或更正。",
  },
  {
    q: "为什么有的名字用化名，有的被模糊处理？",
    a: "我们默认对所有可能被识别的信息做最小化处理：个人用化名、机构用描述性称呼、地点用区域代称。只有在与公共利益高度相关、且信息已经公开可核实的情况下，才会保留更具体的表述。",
  },
  {
    q: "如果发现内容有错误怎么办？",
    a: "我们设有更正机制。读者、信源与被指涉方都可以通过联系方式提出更正请求，附上具体段落和依据。经核实后，我们会在原文位置标注更正说明与时间，而不是悄悄替换内容。",
  },
  {
    q: "本站会替被爆料方下结论吗？",
    a: "不会。我们的职责是呈现可核查的事实线索与多方陈述，把拼图尽量完整地摆出来，而不是充当裁判。涉及法律定性的部分，请以有权机关的结论为准。",
  },
  {
    q: "投稿之后多久会收到反馈？",
    a: "编辑团队通常在三到七个工作日内完成初筛。若线索具备核查价值，我们会通过你留下的安全联系方式跟进；若暂时无法使用，也不会对外公开你的投递内容。",
  },
];